import React, { useState } from 'react';
import { Reveal } from './Reveal';
import { ArrowRight, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function OfferSection() {
  const [isAnnual, setIsAnnual] = useState(false);
  const features = ['Cadastro ilimitado de matérias-primas', 'Produtos e pacotes ilimitados', 'Gestão de encomendas com alerta de prazo', 'Cálculo de preço em tempo real, com seu tempo incluso', 'Histórico de preços de cada produto', 'Alertas automáticos de custo desatualizado', 'Funciona no celular, tablet e computador', 'Exporta tudo em CSV (você nunca fica preso)'];
  const price = isAnnual ? '24' : '29';
  const cents = isAnnual ? ',08' : ',90';
  return <section id="preco" className="py-12 md:py-16 px-[5vw] bg-bg relative overflow-hidden" data-id="element-289">
      {/* Decorative Blob */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-rose-soft/50 rounded-[40%_60%_70%_30%/40%_50%_60%_50%] blur-3xl pointer-events-none z-0" data-id="element-290"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-291">
        <Reveal data-id="element-292">
          <div className="text-center mb-8" data-id="element-293">
            <span className="font-caveat text-rose text-xl md:text-2xl block mb-3" data-id="element-294">
              comece hoje
            </span>
            <h2 className="font-serif font-bold text-[26px] md:text-[clamp(34px,4vw,42px)] tracking-[-0.02em] text-ink mb-3" data-id="element-295">
              Menos do que 1 brigadeiro gourmet por dia.
            </h2>
            <p className="text-[15px] md:text-base text-ink-soft max-w-lg mx-auto" data-id="element-296">
              Um único plano. Sem pegadinha, sem upsell, sem letra miúda. Você
              paga, usa tudo e cancela quando quiser.
            </p>
          </div>
        </Reveal>

        {/* Toggle */}
        <Reveal delay={0.15} data-id="element-297">
          <div className="flex justify-center mb-8" data-id="element-298">
            <div className="relative inline-flex bg-white rounded-full p-1 border border-line shadow-sm" data-id="element-299">
              {/* Sliding indicator */}
              <motion.div className="absolute top-1 bottom-1 rounded-full bg-ink" initial={false} animate={{
              left: isAnnual ? '50%' : '4px',
              right: isAnnual ? '4px' : '50%'
            }} transition={{
              type: 'spring',
              stiffness: 350,
              damping: 30
            }} data-id="element-300" />
              <button onClick={() => setIsAnnual(false)} className={`relative z-10 px-6 py-2 rounded-full text-sm font-medium transition-colors ${!isAnnual ? 'text-white' : 'text-ink-soft'}`} data-id="element-301">
                Mensal
              </button>
              <button onClick={() => setIsAnnual(true)} className={`relative z-10 px-6 py-2 rounded-full text-sm font-medium transition-colors ${isAnnual ? 'text-white' : 'text-ink-soft'}`} data-id="element-302">
                Anual
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-303">
          <div className="max-w-md mx-auto relative" style={{
          marginTop: '14px'
        }} data-id="element-304">
            {/* Badge centralizado acima do card */}
            <AnimatePresence data-id="element-305">
              {isAnnual && <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.8
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 25
            }} className="absolute -top-3.5 left-0 right-0 flex justify-center z-10" data-id="element-306">
                  <span className="bg-[#059669] text-white text-[11px] tracking-wider px-4 py-1 rounded-full whitespace-nowrap" style={{
                fontWeight: 900
              }} data-id="element-307">
                    2 meses grátis
                  </span>
                </motion.div>}
            </AnimatePresence>

            <div className="bg-white rounded-[24px] border border-line p-6 md:p-8 shadow-sm flex flex-col" data-id="element-308">
              <div className="mb-5" data-id="element-309">
                <h3 className="font-serif font-bold text-lg text-ink" data-id="element-310">
                  Plano Aurora
                </h3>
                <p className="text-xs text-ink-soft mt-0.5" data-id="element-311">
                  Tudo que você precisa pra parar de chutar
                </p>
              </div>

              {/* Price */}
              <div className="mb-1" data-id="element-312">
                <div className="flex items-start gap-0.5" data-id="element-313">
                  <span className="font-serif font-bold text-base text-rose mt-1.5" data-id="element-314">
                    R$
                  </span>
                  <motion.span key={price} initial={{
                  opacity: 0,
                  y: -8
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.25
                }} className="font-serif font-extrabold text-[48px] leading-none text-rose tracking-tight" data-id="element-315">
                    {price}
                  </motion.span>
                  <motion.span key={cents} initial={{
                  opacity: 0,
                  y: -8
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.25,
                  delay: 0.05
                }} className="font-serif font-bold text-base text-rose mt-1.5" data-id="element-316">
                    {cents}
                  </motion.span>
                  <span className="text-xs text-ink-soft self-end mb-1.5 ml-1" data-id="element-317">
                    /mês
                  </span>
                  <span className="ml-2 self-end mb-1.5 text-sm font-semibold text-ink bg-gold/15 px-2.5 py-0.5 rounded-full" data-id="element-318">
                    ≈ R$ {isAnnual ? '0,80' : '0,99'}/dia
                  </span>
                </div>
                <p className="text-xs text-ink-soft mt-1" data-id="element-319">
                  {isAnnual ? 'R$ 289,00 cobrado anualmente' : 'cobrado mensalmente'}
                </p>

                <p className="text-[13px] font-semibold text-gold mt-3" data-id="element-320">
                  💰 Menos do que R$ 1 por dia para ter controle total do seu
                  negócio
                </p>
              </div>

              <div className="w-full h-px bg-line my-5" data-id="element-321"></div>

              <div className="space-y-3 mb-6 flex-1" data-id="element-322">
                {features.map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-323">
                    <div className="w-5 h-5 rounded-full bg-rose-soft flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-324">
                      <Check size={12} className="text-rose" data-id="element-325" />
                    </div>
                    <span className="text-[13px] text-ink leading-snug" data-id="element-326">
                      {item}
                    </span>
                  </div>)}
              </div>

              <button className="w-full flex items-center justify-center gap-2 bg-rose text-white py-3 rounded-full font-medium text-sm hover:bg-rose-deep transition-colors animate-[pulseShadow_3s_ease-in-out_infinite]" data-id="element-327">
                Quero começar agora
                <ArrowRight size={14} data-id="element-328" />
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.3} data-id="element-329">
          <p className="text-center text-[12px] text-ink-soft mt-6 flex items-center justify-center gap-1.5" data-id="element-330">
            <span data-id="element-331">🔒</span> Cancela quando quiser · Sem fidelidade · 7 dias de
            garantia (devolvemos 100% se não funcionar pra você)
          </p>
        </Reveal>
      </div>
    </section>;
}